export * from './debounce';
import * as XLSX from 'xlsx';
import { CommonService } from '../services';

export function registerView(profile, error) {
  const { nar_profile_uuid, nar_membership_id } = profile;
  const nar_env =
    window.location.origin === 'https://mentor.apps.realtor' ? 'prod' : 'dev';
  const settings = {
    tealium_enable: 'true',
    nar_env,
    customer_id: nar_profile_uuid || '',
    nrdsid: nar_membership_id || 'N/A',
    error: error | '',
  };
  window.utag.view(settings);
}

export const __HEADERS_URL__ =
  window.location.origin === 'https://mentor.apps.realtor'
    ? 'https://narnav.apps.realtor'
    : 'https://narnav-dev.apps.realtor';

export async function generateXLSX(data, name, getQuestions) {
  const questions = await getQuestions();
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(
    data.map((row) => {
      const newRow = {};
      Object.entries(row).forEach(([k, v]) => {
        const questionID = v?.QuestionID || v?.questionID;
        const question = questions.find(
          (question) => question.ID === questionID
        );
        if (question?.QuestionDescription) {
          newRow[question.QuestionDescription] = v?.Value || v?.value || v;
        } else {
          newRow[k] = v.split('T')[0];
        }
      });
      return newRow;
    })
  );
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Responses');
  XLSX.writeFile(workbook, name + '.xlsx');
}

export const fetchMentorRecords = async () => {
  const storedSubmissions = await CommonService.getResponses('MentorResponses');
  const submissions = {};
  storedSubmissions.forEach((submission) => {
    const { Created, UserID, QuestionDescription, QuestionID, Value, ID } =
      submission;

    if (submissions[UserID]) {
      submissions[UserID][QuestionID] = {
        ID,
        Value,
        QuestionID,
        QuestionDescription,
      };
    } else {
      submissions[UserID] = {
        UserID,
        Created,
        [QuestionID]: {
          ID,
          Value,
          QuestionID,
          QuestionDescription,
        },
      };
    }
  });
  const responses = Object.values(submissions);
  return responses;
};

export const fetchMenteeRecords = async () => {
  const storedSubmissions = await CommonService.getResponses('MenteeResponse');
  const submissions = {};
  storedSubmissions.forEach((submission) => {
    const { Created, userid, QuestionDescription, questionID, value, ID } =
      submission;

    if (submissions[userid]) {
      submissions[userid][questionID] = {
        ID,
        value,
        questionID,
        QuestionDescription,
      };
    } else {
      submissions[userid] = {
        UserID: userid,
        Created,
        [questionID]: {
          ID,
          value,
          questionID,
          QuestionDescription,
        },
      };
    }
  });
  const responses = Object.values(submissions);
  return responses;
};
